import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-success-dialog',
    styleUrls: ['./success-dialog.component.css'],
    templateUrl: './success-dialog.component.html',
    standalone: false
})
export class SuccessDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string, link: string, linkText: string}) { }
}